import Common from '../common/CommonPowerbook';

class TmplObjectNPC {

    constructor() {
        this.comm = Common.instance;
    }

    make(_d){
         return `
<section class="object object-monster">
    <header class="object__header">
        <img class="object__icon" src="${this.comm.staticImgURL}/powerbook/lineage/${_d.image}" alt="">
        <span class="object__name"><a href="${this.comm.powerbookURL}/${_d.name}">${_d.name}</a></span>
    </header>
    <article class="object__attribute">
        <table>
            <tbody>
                <tr>
                    <th scope="col">지역</th>
                    <td><a href="${this.comm.powerbookURL}/${_d.location}">${_d.location}</a></td>
                </tr>
                <tr>
                    <th scope="col">기능</th>
                    <td>${_d.job||'-'}</td>
                </tr>
                <tr>
                    <th scope="col">관련 퀘스트</th>
                    <td>${_d.quest_name||'-'}</td>
                </tr>
                <tr>
                    <th scope="col">설명</th>
                    <td>${_d.description||'-'}</td>
                </tr>
            </tbody>
        </table>
    </article>
</section>`
    }

}

export default TmplObjectNPC;




// WEBPACK FOOTER //
// ./lineage/TmplObjectNPC.js